import { getAPICall } from "./config"
import { accessToken, previewRootUrl, rootUrl, sortConfig } from "./constant"
import { getBlogsList, getFeaturedBlogsList, getPinnedBlogsList } from "@/redux-store/slices/blogs"
import TeamsData from '@/assets/data/job-categories.json'
import { getCaseStudiesList, getFeaturedCaseStudiesList, getPinnedCaseStudiesList } from "@/redux-store/slices/casestudy"
import { getFeaturedPressList, getPinnedPressList, getPressList } from "@/redux-store/slices/press"

export const getBlogsListAPI = (setLoader = () => { }, pageData, setPageData = () => { }) => {
  const isPinnedList = pageData?.category === "pinned"
  const isFeaturedList = pageData?.category === "featured"
  const options = {
    headers: {
      Token: accessToken
    }
  }

  return (dispatch) => {
    getAPICall(`${rootUrl}/blog/list?size=${pageData?.pageSize}&page=${pageData?.page}&category=${pageData?.category === "all" ? "" : pageData?.category || ""}&searchKey=${pageData?.searchKey || ""}&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options)
      .then(res => {
        setLoader(false)
        if (isPinnedList) {
          dispatch(getPinnedBlogsList(res))
        } else if (isFeaturedList) {
          dispatch(getFeaturedBlogsList(res))
        } else {
          setPageData(data => ({ ...data, totalCount: res?.total || 0 }))
          dispatch(getBlogsList(res))
        }
      })
      .catch(err => {
        setLoader(false)
        console.log({ err })
      })
  }
}

export const getCaseStudyListAPI = (setLoader = () => { }, pageData, setPageData = () => { }) => {
  const isPinnedList = pageData?.category === "pinned"
  const isFeaturedList = pageData?.category === "featured"
  const options = {
    headers: {
      Token: accessToken
    }
  }

  return (dispatch) => {
    getAPICall(`${rootUrl}/caseStudy/list?size=${pageData?.pageSize}&page=${pageData?.page}&category=${pageData?.category || ""}&searchKey=${pageData?.searchKey || ""}&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options)
      .then(res => {
        setLoader(false)
        if (isPinnedList) {
          dispatch(getPinnedCaseStudiesList(res))
        } else if (isFeaturedList) {
          dispatch(getFeaturedCaseStudiesList(res))
        } else {
          setPageData(data => ({ ...data, totalCount: res?.total || 0 }))
          dispatch(getCaseStudiesList(res))
        }
      })
      .catch(err => {
        setLoader(false)
        console.log({ err })
      })
  }
}

export const getPressListAPI = (setLoader = () => { }, pageData, setPageData = () => { }) => {
  const isPinnedList = pageData?.category === "pinned"
  const isFeaturedList = pageData?.category === "featured"
  const options = {
    headers: {
      Token: accessToken
    }
  }

  return (dispatch) => {
    getAPICall(`${rootUrl}/press/list?size=${pageData?.pageSize}&page=${pageData?.page}&category=${pageData?.category || ""}&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options)
      .then(res => {
        setLoader(false)
        if (isPinnedList) {
          dispatch(getPinnedPressList(res))
        } else if (isFeaturedList) {
          dispatch(getFeaturedPressList(res))
        } else {
          setPageData(data => ({ ...data, totalCount: res?.total || 0 }))
          dispatch(getPressList(res))
        }
      })
      .catch(err => {
        setLoader(false)
        console.log({ err })
      })
  }
}

export const getJobDataAPI = (id, setData, setLoader) => {

  return () => {
    getAPICall(`/api/job-data?id=${id}`)
      .then(res => {
        setData(res)
        setLoader(false)
      })
      .catch(err => {
        setLoader(false)
        console.error('Error fetching blog data:', err);
      })
  }
}

// SSR API list


export const getBlogDataAPI = async (blog) => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/blog/view?category=${blog?.category}&slug=${blog?.slug}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};


export const getResourcePreviewDataAPI = async (blog) => {
  const options = {
    headers: {
      Authorization: 'Bearer ' + blog?.authToken
    }
  }

  try {
    const response = await getAPICall(`${previewRootUrl}/${blog?.category}/view?id=${blog?.id}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getCaseStudyDataAPI = async (blog) => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/caseStudy/view?category=${blog?.category}&slug=${blog?.slug}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getPressDataAPI = async (blog) => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/press/view?category=${blog?.category}&slug=${blog?.slug}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getFeaturedResourcesListAPI = async (resourcesCategory) => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/${resourcesCategory}/list?category=featured&page=1&size=10&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getFeaturedBlogsListAPI = async () => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/blog/list?category=featured&page=1&size=10&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getRecentPublicationsAPI = async (category) => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/${category}/list?category=&page=1&size=10&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getFeaturedCaseStudyListAPI = async () => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/caseStudy/list?category=featured&page=1&size=10&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getFeaturedPressListAPI = async () => {
  const options = {
    headers: {
      Token: accessToken,
    },
  };

  try {
    const response = await getAPICall(`${rootUrl}/press/list?category=featured&page=1&size=10&sortBy=${sortConfig?.sortBy}&sortOrder=${sortConfig?.sortOrder}`, options);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getJobsListAPI = async () => {
  try {
    const response = await getAPICall(`https://api.hyqoo.com:9090/api/job/postedJobs`);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getJobFullDataAPI = async (id) => {
  try {
    const response = await getAPICall(`https://api.hyqoo.com:9090/api/job/getRequisitionByIdWebsite?requisitionId=${id}`);
    return response;
  } catch (err) {
    console.error('Error fetching blog data:', err);
    throw err;
  }
};

export const getTalentCategoryData = async (category) => {
  let categoryData = TeamsData?.find(e => e?.slug === category)

  if (categoryData) {
    return categoryData
  }

  throw null
};
